window.theme = window.theme || {};

window.theme.sizes = {
  mobile: 480,
  small: 768,
  large: 1024,
  widescreen: 1440,
};

window.theme.keyboardKeys = {
  TAB: 'Tab',
  ENTER: 'Enter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
  LEFTARROW: 'ArrowLeft',
  RIGHTARROW: 'ArrowRight',
};

window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
